import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 31 41",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 41\" id=\"icon-phone\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.738 2.573C4.246 1.14 6.718-1.125 7.677.652L12.7 9.958c-.746 2.212-3.391 3.25-5.33 3.875.975 5.842 6.854 14.827 11.65 17.805 1.213-1.735 3.028-4.041 5.225-4.035l6.454 8.235c1.232 1.572-1.602 3.283-3.376 4.309C14.18 46.74-7.708 13.29 2.738 2.573Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol